import React from 'react'
import PropTypes from 'prop-types'
import config from './SizeGuideConfig'
import classNames from 'classnames'
import styles from './SizeGuide.module.scss'

const SizeGuide = ({
    productCode
}) => {
    if (!productCode || !config[`${productCode}`]) {
        return <></>
    }
    const { head, body, footer } = config[`${productCode}`]

    if (!head || !body) {
        return <></>
    }
    const renderTHead = (headContent) => {
        const headContentClass = classNames({
            [styles[headContent.className]]: headContent.className
        })
        return (
            <thead className={headContentClass}>
                <tr>
                    {headContent.content.map((headItem, headIndex) => {
                        const headItemClass = classNames({
                            [styles[headItem.className]]: headItem.className
                        })
                        const headItemTitleClass = classNames({
                            [styles[headItem.titleClassName]]: headItem.titleClassName
                        })
                        return <th className={headItemClass} key={`table-head-${headIndex}`}>
                            {!headItem.subtitle && <span className={`t-600 u-displayBlock ${headItemTitleClass}`}>{headItem}</span>}
                            {(headItem.subtitle && headItem.title) && <span className={`t-600 u-displayBlock ${headItemTitleClass}`}>{headItem.title}</span>}
                            {headItem.subtitle && <span className={`${headItemTitleClass} u-displayBlock `}>{headItem.subtitle}</span>}
                        </th>
                    })}
                </tr>
            </thead>
        )
    }

    const renderTBody = (rows) => {
        return (
            <tbody>
                {rows.content.map((rowContent, index) => {
                    const rowContentClass = classNames({
                        [styles[rowContent.className]]: rowContent.className
                    })
                    return <tr className={rowContentClass} key={`table-row-${index}`}>
                        {rowContent.map((cellItem, cellIndex) => {
                            const cellItemClass = classNames({
                                [styles[cellItem.className]]: cellItem.className,
                                [cellItem.classNameList]: cellItem.classNameList
                            })
                            return <td key={`table-cell-item-${cellIndex}`} className={cellItemClass} rowSpan={`${cellItem.rowSpan && cellItem.rowSpan}`} dangerouslySetInnerHTML={{ __html: cellItem.title || cellItem }}></td>
                        })}
                    </tr>
                })}
            </tbody>
        )
    }

    const renderFooter = (footer) => {
        return (
            <div className={styles.footer}>
                {footer.listContent.map((item, index) => {
                    return item && <p className={styles.moreDetails} dangerouslySetInnerHTML={{ __html: item }} key={`footer-${index}`}></p>
                })}
            </div>
        )
    }

    return (
        <React.Fragment>
            <table className={`${styles.table} ${styles.sheets} u-hidden-md-down`}>
                {renderTHead(head)}
                {renderTBody(body)}
            </table>
            {footer && renderFooter(footer)}
        </React.Fragment>
    )
}

SizeGuide.propTypes = {
    productCode: PropTypes.string
}

export default SizeGuide

